
import React, { useState, useEffect, memo } from 'react';
import { IoMdClose } from "react-icons/io";

import { useGlobalState } from '../../../global_state_components/GlobalStateProvider.jsx';
import styles from './sessionBookedOverlayForDiscussAndLearn.module.css';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from 'react-router-dom';
import { axiosInstance } from '../../../../lib/axiosInstance.js';

//Wrapping the whole component with memo.
const SessionBookedOverlayForDiscussAndLearn = memo(function(props){
  const navigate = useNavigate();
  const {isMobile, heightOfCalendarGrid, setShowStrangersList, setShowFriendsList} = useGlobalState();

  //----Entered topic handling (down)--------------------
  const [bookingStatus, setBookingStatus] = useState('Matching1');  //I think not required. That's why for now given a value of 'Matching1'.
  const [bookedTimeSlot, setBookingTimeSlot] = useState('11 AM-12.30 PM');
  //const [bookedSubject, setBookedSubject] = useState('Physics');
  //const [bookedTopic, setBookedTopic] = useState('Lasers');

  const isTime10MinutesBeforeSession = true;   //For join button.

  const [showCancelSessionInOverlay, setShowCancelSessionInOverlay] = useState(false);
  //const [cancelSession, setCancelSession] = useState(); //I think has to be a global state. And when this happens the session has to deleted from the database.








  //-----------Adding 1 and a half hours and alse checking if it's am or pm.---------------  

  let amPm = props.bookedHour >= 12 ? "PM" : "AM";   //Deciding if props.bookedHour is am or pm.

  function convertTo12HourFormat(hour) {
    hour = hour % 12 || 12; // Convert 0 to 12 for 12-hour format
    return hour;
  }

  function addOneAndHalfHours(bookedHour, bookedMinute) {
    // Add 1 hour to bookedHour
    let newHour = (bookedHour + 1) % 24;

    // Add 30 minutes
    let newMinute = (bookedMinute + 30) % 60;

    // If adding 30 minutes caused overflow, increment the hour
    if (bookedMinute + 30 >= 60) {
        newHour = (newHour + 1) % 24;
    }

    // Determine AM/PM based on the new hour
    let amPm = newHour >= 12 ? "PM" : "AM";

    // Convert newHour to 12-hour format
    let hourIn12 = convertTo12HourFormat(newHour);

    return {
        hour: hourIn12,
        minute: newMinute,
        amPm: amPm
    };
  }

  // Example usage with props
  let bookedHour = props.bookedHour; // In 24-hour format
  let bookedMinute = props.bookedMinute; // Values like 0, 15, 30, 45

  const newTime = addOneAndHalfHours(bookedHour, bookedMinute);

  //console.log(`${newTime.hour}:${newTime.minute.toString().padStart(2, '0')} ${newTime.amPm}`);
  //---------------






  //---------Cancel session handling -------------
  const cancelSession = async () => {
    try {
      // const response = await axiosInstance.delete(`/sessions/${props.sessionId}`);
      // console.log("Session cancelled successfully:", response.data);
      // setBookingStatus('Cancelled');
    } catch (error) {
      // console.error('Error cancelling session:', error);
      // if (error.response) {
      //   // Server responded with a status other than 200 range
      //   console.log("Error Data: ", error.response.data);
      // }
    }
  }







  
  /*
  //fetch your profile id
  const [yourProfileId, setYourProfileId] = useState('');
  useEffect(() => {
    const fetchYourProfileId = async () => {
      try {
        const response = await axiosInstance.get('/profile');
        setYourProfileId(response.data._id);
      } catch (error) {
        console.error('Error fetching profile details:', error);
        if (error.response) {
          // Server responded with a status other than 200 range
          console.log("Error Data: ", error.response.data);
        }
      }
    }

    fetchYourProfileId();
  }, []);




  //find your partner id
  const [partnerId, setPartnerId] = useState('');
  useEffect(() => {
    if (props.isPaired===true) {
      const yourPartnerId = (yourProfileId === props.createdPersonId) ? props.pairedWithPersonId : props.createdPersonId;
      setPartnerId(yourPartnerId);
    }
  }, [yourProfileId, props.createdPersonId, props.pairedWithPersonId, props.isPaired]);




  

  //fetch your partner name
  const [partnerName, setPartnerName] = useState('');
  useEffect(() => {
    const fetchYourPartnerName = async (partnerId) => {
      try {
        const response = await axiosInstance.get(`/profile/?userID=${partnerId}`);
        setPartnerName(response.data.name);
      } catch (error) {
        console.error('Error fetching profile details:', error);
        if (error.response) {
          // Server responded with a status other than 200 range
          console.log("Error Data: ", error.response.data);
        }
      }
    }

    fetchYourPartnerName(partnerId);  
  }, [partnerId]);   


  */





  // const [createdPersonName, setCreatedPersonName] = useState('');
  // useEffect(() => {
  //   const fetchCreatedPersonName = async (createdPersonId) => {
  //     try {
  //       const response = await axiosInstance.get(`/profile/?userID=${createdPersonId}`);
  //       setCreatedPersonName(response.data.name);
  //     } catch (error) {
  //       console.error('Error fetching profile details:', error);
  //       if (error.response) {
  //         // Server responded with a status other than 200 range
  //         console.log("Error Data: ", error.response.data);
  //       }
  //     }
  //   }

  //   fetchCreatedPersonName(props.createdPersonId);
  // }, [props.createdPersonId]);
  






  //Modify...
  /*
  const [partnerName, setPartnerName] = useState('Your upcoming sessions appear here.');
  const [partnerId, setPartnerId] = useState('');

  useEffect(() => {
    const fetchMySessions = async () => {
      try {
        const response = await axiosInstance.get('/sessions/mine');
        const sessions = response.data;

        // Filter out the upcoming session
        const currentTime = dayjs();
        const upcoming = sessions
          .filter(session => dayjs(session.time).isAfter(currentTime))
          .sort((a, b) => dayjs(a.time).diff(dayjs(b.time)))[0];

        setUpcomingSession(upcoming);

        if (upcoming) {
          const profileResponse = await axiosInstance.get('/profile');
          const myProfileId = profileResponse.data._id;
          if (myProfileId === upcoming.createdBy) {
            if (upcoming.isPaired){   //Or if (upcoming.pairedWith)
              const partnerResponse = await axiosInstance.get(`/profile/?userID=${upcoming.pairedWith}`);
              setPartnerId(upcoming.pairedWith);
              setPartnerName(partnerResponse.data.name);
            }else{   //Or if (!upcoming.pairedWith)
              setPartnerName('Matching...');
            }
          } else {   //Or else if (myProfileId === upcoming.pairedWith)
            const partnerResponse = await axiosInstance.get(`/profile/?userID=${upcoming.createdBy}`);
            setPartnerId(upcoming.createdBy);
            setPartnerName(partnerResponse.data.name);
          }
        }
      } catch (error) {
        console.error('Error fetching my sessions:', error);
      }
    };

    fetchMySessions();

    //Here we are polling every 40 seconds. Not sure if this the best way because we are calling the sessions/mine API already in the DiscussAndLearnArea component and SilentStudyArea component.
    const interval = setInterval(fetchMySessions, 10000);

    return () => clearInterval(interval);
    
  }, []);
  */
  


  const [partnerId, setPartnerId] = useState('');
  const [partnerName, setPartnerName] = useState('Matching...');
  useEffect(() => {
    try {
      async function getPartnerDetails() {
        const profileResponse = await axiosInstance.get('/profile');
        const myProfileId = profileResponse.data._id;
        if (myProfileId === props.createdPersonId) {
          if (props.isPaired){   //Or if (upcoming.pairedWith)
            const partnerResponse = await axiosInstance.get(`/profile/?userID=${props.pairedWithPersonId}`);
            setPartnerId(props.pairedWithPersonId);
            setPartnerName(partnerResponse.data.name);
          }else{   //Or if (!upcoming.pairedWith)
            setPartnerName('Matching...');
          }
        } else {   //Or else if (myProfileId === upcoming.pairedWith)
          const partnerResponse = await axiosInstance.get(`/profile/?userID=${props.createdPersonId}`);
          setPartnerId(props.createdPersonId);
          setPartnerName(partnerResponse.data.name);
        }
      }
    
      getPartnerDetails();

    } catch (error) {
      console.error('Error fetching partner details:', error);
    } 

  }, []);







  if (showCancelSessionInOverlay===true){
    return(
      <div className={styles.clicked_overlay} style={{height : `${6*heightOfCalendarGrid+3}px`}}>
        <div className={styles.enter_topic_message_div}>Cancel?</div>
        <div onClick={()=>setShowCancelSessionInOverlay(false)} className={styles.enter_topic_message_div}>No</div>
        {/* <div onClick={()=>setCancelSession()} className={styles.enter_topic_message_div}>Yes</div> */}
      </div>
    )
  }else if (showCancelSessionInOverlay===false){
    return(
      (bookingStatus!=='Matching')?(
        <div className={styles.clicked_overlay} style={{height : `${6*heightOfCalendarGrid+3}px`}}>
          <div className={styles.person_details_div}>
            {
              (props.isPaired===true) && <Avatar className={styles.avatar_class} alt="booked_against_person_image" src={`${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${partnerId}&type=thumbnail`}/>
            }
            <p className={styles.person_name_class}>{partnerName}</p>
          </div>

          {/*<div className={styles.enter_topic_message_div}>{bookedTimeSlot}</div>*/}
          <div className={styles.enter_topic_message_div}>{convertTo12HourFormat(props.bookedHour)}.{props.bookedMinute} {amPm}-{newTime.hour}.{newTime.minute.toString().padStart(2, '0')} {newTime.amPm} </div>

          <div className={styles.enter_topic_message_div}>{props.bookedSubject}</div>
          <div className={styles.enter_topic_message_div}>{props.bookedTopic}</div>
          {/* <div className={styles.enter_topic_message_div}>{props.isPaired}</div> */}
          {/* <div className={styles.enter_topic_message_div}>{props.bookedMode}</div> */}
          <div className={styles.enter_topic_message_div}>{(props.bookedType==='Discuss and learn with partner')? 'Discuss and learn' : 'Silent study'}</div>
          {
            isTime10MinutesBeforeSession===true && (
              <button onClick={() => navigate("/video_call_page")} className={styles.slot_book_any_button}> 
                Join
              </button>
            )
          }
          <IoMdClose onClick={()=>setShowCancelSessionInOverlay(true)} className={styles.close_icon}/>
        </div>
      ):(
        <div className={styles.clicked_overlay} style={{height : `${6*heightOfCalendarGrid+3}px`}}>
          <div className={styles.enter_topic_message_div}>{bookingStatus}</div>
        </div>
      )
    )
  }

}


)   //End of memo function.

export default SessionBookedOverlayForDiscussAndLearn;

